import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { UserProvider } from './sessionmanagement/UserContext'; // <-- Import provider
import GlobalStyles from './styles/GlobalStyles'; // ✅ Import global styles

import { useEffect } from 'react';
import { initGA,  } from './utils/analytics/GoogleAnalytics';
import GoogleAnalyticsTracker from './utils/analytics/GoogleAnalyticsTracker';

import ActivationPaywall from './onboarding/activation/ActivationPaywall';


// prototype 
import ChartFlashRevealPrototype from './onboarding/activation/ChartFlashRevealPrototype.jsx'; // For React Web Drag drop 
import ChartFlashGestureWeb from './onboarding/activation/prototype/ChartFlashGestureWeb';  // For React Native
//import ChartFlashRevealLive from './onboarding/activation/prototype/ChartFlashGestureWebPrototype';   // only gestures no drag drop


import ChartFlashGestureLessonWeb from './onboarding/activation/prototype/ChartFlashGestureLessonWeb';  // For React Web
import ChartArrowFollowLesson from './onboarding/activation/prototype/ChartArrowFollowLesson';


import BookACall from './pages/BookACall';



// import Day1Route from "./onboarding/activation/Day1Route";

import Day1QuestIntro from './onboarding/activation/Day1QuestIntro';
import Day1TorroExperience from './onboarding/activation/Day1TorroExperience';



// ✅ Core Pages
import Bootypage from './Bootypage';
import WelcomePage from './Pages2/WelcomePage';
import WelcomeLogin from './Pages2/WelcomeLogin';
import Quizpage from './Pages2/Quizpage';

// ✅ Onboarding Pages
import CourseSelection from './onboarding/preactivation/CourseSelection';
import FindCourseSkillLevel from './onboarding/preactivation/FindCourseSkillLevel';
import FindMySkillLevelStep2 from './onboarding/preactivation/FindMySkillLevelStep2';
import GetReadySkillTest from './onboarding/preactivation/GetReadySkillTest';
import OnboardingSkillTest from './onboarding/activation/OnboardingSkillTest';

import Paywall from './onboarding/activation/Paywall';

import Thankyou from './onboarding/activation/Thankyou';


import ProductMarketFitDashboard from './analytics/ProductMarketFitDashboard';

import GlobalTalentVisa from './analytics/globaltalentvisa';

// ✅ Post-Activation Pages
import PostActivationQuotePage from './onboarding/postactivation/PostActivationQuotePage';
import PostActivationCoinsEarnedPage from './onboarding/postactivation/PostActivationCoinsEarnedPage';
import PostActivationStreakCountPage from './onboarding/postactivation/PostActivationStreakCountPage';
import PostActivationStreakCommitPage from './onboarding/postactivation/PostActivationStreakCommitPage';
import PostActivationStreakCommitRewardPage from './onboarding/postactivation/PostActivationStreakCommitRewardPage';

// ✅ Course Pages
import CourseLanding from './course/CourseLanding';



import PracticeSessionPlay from './practicesession/PracticeSessionPlay';


// ✅ New Practice Session Pages
import PracticeSessionQuestions from './practicesession/PracticeSessionQuestions';
import PracticeSessionPostCompletionFeedBackQuestion from './practicesession/PracticeSessionPostCompletionFeedBackQuestion';
import PracticeSessionPostCompletion from './practicesession/postpracticesession/PracticeSessionPostCompletion';
import FinalQuotes from './practicesession/FinalQuotes';

// ✅ Practice Session Sub-Pages
import MultipleChoicePSQuestion from './practicesession/MultipleChoicePSQuestion';
import MultipleChoiceChartPSQuestion from './practicesession/MultipleChoiceChartPSQuestion';
import TrueFalsePSQuestion from './practicesession/TrueFalsePSQuestion';
import TrueFalseChartPSQuestion from './practicesession/TrueFalseChartPSQuestion';
import MatchTheFollowingPSQuestion from './practicesession/MatchTheFollowingPSQuestion';
import MatchTheFollowingChartPSQuestion from './practicesession/MatchTheFollowingChartPSQuestion';



// ✅ Practice Session Post Completion Feedback Question Sub-Pages

import TrueFalsePostPSCompletionFeedBackQuestion from './practicesession/TrueFalsePostPSCompletionFeedBackQuestion';


import MagicMoment from './onboarding/activation/MagicMoment';
import MagicMomentLogin from './onboarding/activation/MagicMomentLogin';
import CoinsReward from './Pages2/CoinsReward';
import CoinsRewardLogin from './Pages2/CoinsRewardLogin';


// For Ask the chart agent
import AskTheChartInsights from './agents/askthechart/insights';

import InsightsOnboard from './agents/askthechart/InSightsOnboard.jsx';

import ReimaginedChartInsights from './agents/askthechart/ReimaginedChartInsights.jsx';
import TestChart from './TestChart.jsx';

import StarttraderChallenge from './challenges/startrader/StarTraderChallenge';


import ProtectedRoute from './components/routing/ProtectedRoute.jsx';




import AgentAccess from './AgentAccess';




// ✅ 5-Minute Timed Challenge Components
import ChallengeAccess from './ChallengeAccess';
import ChallengeWelcome from './challenges/ChallengeWelcome';
import ChallengeSkillTest from './challenges/ChallengeSkillTest';
import ChallengeMultipleChoiceQuestionLiveChart from './challenges/ChallengeMultipleChoiceQuestionLiveChart';
import ChallengeTimeOut from './challenges/ChallengeTimeOut';
import ChallengeSuccess from './challenges/ChallengeSuccess';


//Analytics

import PirateMetricsDashboard from './analytics/PirateMetricsDashboard.jsx';


//Homepage

import HomePage from './pages/HomePage'; // ⬅️ New homepage component

//AgentsHome

import AgentsHome from './pages/AgentsHome';


//Aha moment with AI
import AhaMomentAILanding from './pages/AhaMomentAILanding';
import MarketMovesDecoderAILanding from './pages/MarketMovesDecoderAILanding.jsx';
import CryptoClarityAILanding from './pages/CryptoClarityAILanding.jsx';
import AhaMomentChatSessionPage from './pages/AhaMomentChatSessionPage';





//Prop Funding Expo AI Landing
import PropFundingAILanding from './pages/PropFundingAILanding';
import PropFundingChatSessionPage from './pages/PropFundingChatSessionPage';
import PropFundingEmailAccess from './PropFundingEmailAccess.jsx';
import AskChartPropFunding from './agents/askthechart/AskChartPropFunding';


//London Trader Show Expo AI Landing
import TradingAILanding from './pages/TradingAILanding';
import TradingChatSessionPage from './pages/TradingChatSessionPage';

import InvestingAILanding from './pages/InvestingAILanding';
import InvestingChatSessionPage from './pages/InvestingChatSessionPage';



import './styles/variables.css';
import './styles/global.css';


import ActivationIntroSequence from "./onboarding/activation/ActivationIntroSequence";

import TemplateOnboardingAndLessonScreen from "./templates/TemplateOnboardingAndLessonScreen.jsx";





const App = () => {

  useEffect(() => {
    initGA();
  }, []);
  

 return (
    <UserProvider> {/* <-- Wrap your Router with UserProvider */}
      <Router>
        {/* ✅ Apply global styles */}
        <GoogleAnalyticsTracker />
        <GlobalStyles />
        <Routes>
          {/* ✅ Core Pages */}
          {/* <Route path="/" element={<Bootypage />} /> */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Bootypage />} />  

          {/* <Route path="/home" element={<HomePage />} />  */}
          {/* 🔥 New homepage route */}


          <Route path="/quiz" element={<Quizpage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/welcome-login" element={<WelcomeLogin />} />

          {/* ✅ Onboarding Pages */}
          <Route path="/courses" element={<CourseSelection />} />
          <Route path="/find-course-skill-level" element={<FindCourseSkillLevel />} />
          <Route path="/find-my-skill-level-step" element={<FindMySkillLevelStep2 />} />
          <Route path="/get-ready-skill-test" element={<GetReadySkillTest />} />
          <Route path="/onboarding-skill-test-new" element={<OnboardingSkillTest />} />

          <Route path="/paywall" element={<Paywall />} />

          <Route path="/thankyou" element={<Thankyou/>} />





          
             {/* ✅ // Updated routes inside <Routes>: */}

<Route path="/amm" element={<MagicMoment />} />
<Route path="/amm-login" element={<MagicMomentLogin />} />

<Route path="/coins-reward" element={<CoinsReward />} />
<Route path="/coins-reward-login" element={<CoinsRewardLogin />} />



{/* <Route path="/onboarding/day1quest" element={<Day1Route />} />
<Route path="/onboarding/day1" element={<Day1Route />} /> */}



<Route path="/onboarding/quest" element={<Day1QuestIntro />} />
<Route path="/onboarding/day1" element={<Day1TorroExperience />} />




          {/* ✅ Post-Activation Pages */}
          <Route path="/post-activation-quote" element={<PostActivationQuotePage />} />
          <Route path="/post-activation-coins-earned" element={<PostActivationCoinsEarnedPage />} />
          <Route path="/post-activation-streak-count" element={<PostActivationStreakCountPage />} />
          <Route path="/post-activation-streak-commit" element={<PostActivationStreakCommitPage />} />
          <Route path="/post-activation-streak-commit-reward" element={<PostActivationStreakCommitRewardPage />} />

          {/* ✅ Course Pages */}
          <Route path="/course-landing" element={<CourseLanding />} />

          {/* ✅ Practice Session Pages */}


          <Route path="/practice-session-play/:lessonId/:topicId" element={<PracticeSessionPlay />} />

          <Route path="/practice-session" element={<PracticeSessionQuestions />} />


      
          
          <Route path="/practice-session-post-completion" element={<PracticeSessionPostCompletion />} />
          <Route path="/practice-session-post-completion-feedback" element={<PracticeSessionPostCompletionFeedBackQuestion />} />


          <Route path="/practice-final-quotes" element={<FinalQuotes />} />

          {/* ✅ Practice Session Sub-Pages */}
          <Route path="/practice-multiple-choice" element={<MultipleChoicePSQuestion />} />
          <Route path="/practice-multiple-choice-chart" element={<MultipleChoiceChartPSQuestion />} />
          <Route path="/practice-true-false" element={<TrueFalsePSQuestion />} />
          <Route path="/practice-true-false-chart" element={<TrueFalseChartPSQuestion />} />
          <Route path="/practice-match-the-following" element={<MatchTheFollowingPSQuestion />} />
          <Route path="/practice-match-the-following-chart" element={<MatchTheFollowingChartPSQuestion />} />


          {/* ✅ Practice Session Post Completion Sub-Pages */}




          {/* ✅ Ask the Chart Newsletter */}
        <Route path="/ask-the-chart" element={<AskTheChartInsights />} />  

        <Route path="/magic-moment-ai-onboard" element={<InsightsOnboard />} />


        <Route path="/home" element={<HomePage />} />

        <Route path="/agents" element={<AgentsHome />} />

       
        <Route path="/book-a-call" element={<BookACall />} />


        <Route path="/onboarding/activation/subscribe" element={<ActivationPaywall />} />

        

{/* <Route path="/ask-the-chart" element={
  <ProtectedRoute>
    <AskTheChartInsights />
  </ProtectedRoute>
} /> */}








        
         

       <Route path="/smartchart" element={<ReimaginedChartInsights />} />


       <Route path="/testchart" element={<TestChart />} />


      {/* 🚀 New Challenge Landing Page */}

      <Route path="/startrader-challenge" element={<StarttraderChallenge />} />


      {/* Inside your <Routes> */}
      <Route path="/agent-access" element={<AgentAccess />} />


      {/* ✅ 5-Minute Timed Challenge Flow */}
<Route path="/challenge-access" element={<ChallengeAccess />} />
<Route path="/challenge-welcome" element={<ChallengeWelcome />} />
<Route path="/challenge-skill-test" element={<ChallengeSkillTest />} />
<Route path="/challenge-mcq-chart" element={<ChallengeMultipleChoiceQuestionLiveChart />} />
<Route path="/challenge-timeout" element={<ChallengeTimeOut />} />
<Route path="/challenge-success" element={<ChallengeSuccess />} />




<Route path="/dashboard/pmf" element={<ProductMarketFitDashboard />} />
<Route path="/dashboard/pirate-metrics" element={<PirateMetricsDashboard />} />

<Route path="/dashboard/gtv" element={<GlobalTalentVisa />} />


<Route path="/aha-moment" element={<AhaMomentAILanding />} />
<Route path="/market-moves-decoder" element={<MarketMovesDecoderAILanding />} />
<Route path="/crypto-clarity" element={<CryptoClarityAILanding />} />
<Route path="/learn/space/:chatsessionid" element={<AhaMomentChatSessionPage />} />



 {/* ✅ Route for London Prop Trading Expo*/}
<Route path="/prop-funding-landing" element={<PropFundingAILanding />} />
<Route path="/learn/propfunding/space/:chatsessionid" element={<PropFundingChatSessionPage />} />
<Route path="/prop-funding-email-access" element={<PropFundingEmailAccess />} />
<Route path="/ask-the-chart-prop-funding" element={<AskChartPropFunding/>} />


 {/* ✅ Route for London  Trading  Show Expo*/}
<Route path="/trading" element={<TradingAILanding />} />
<Route path="/learn/trading/space/:chatsessionid" element={<TradingChatSessionPage />} />

<Route path="/investing" element={<InvestingAILanding />} />
<Route path="/learn/investing/space/:chatsessionid" element={<InvestingChatSessionPage />} />



{/* // Gamified Prototypes */}

<Route path="/onboarding/flash" element={<ChartFlashRevealPrototype />} />
<Route path="/onboarding/flash-gesture" element={<ChartFlashGestureWeb />} />
{/* <Route path="/onboarding/flash-gesture-web" element={<ChartFlashGestureLessonWeb />} />  */}
<Route path="/prototype/onboarding/lesson" element={<ChartArrowFollowLesson />} />


<Route path="/onboarding/intro" element={<ActivationIntroSequence />} />




{/* // Standard html template for fintorro */}

<Route
  path="/templates/onboarding-lesson"
  element={
    <TemplateOnboardingAndLessonScreen
      title="Mission: Title"
      progress={60}
      lives={5}
      canContinue={true}
      onContinue={() => alert("Continue clicked!")}
      onSkip={() => alert("Skip clicked!")}
      onClose={() => alert("Close clicked!")}
    >
      <div
        style={{
          width: 160,
          height: 160,
          background: "rgba(255,255,255,0.1)",
          borderRadius: 16,
          display: "grid",
          placeItems: "center",
          fontSize: 24,
          color: "#fff",
        }}
      >
        🎬 Content Block here 
      </div>
    </TemplateOnboardingAndLessonScreen>
  }
/>








        </Routes>
      </Router>
    </UserProvider>
  );
};

export default App;







// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { UserProvider } from './sessionmanagement/UserContext'; // <-- Import provider

// import Bootypage from './Bootypage';
// import WelcomePage from './Pages2/WelcomePage';
// import Quizpage from './Pages2/Quizpage';
// import CourseSelection from './onboarding/preactivation/CourseSelection';
// import FindCourseSkillLevel from './onboarding/preactivation/FindCourseSkillLevel';
// import FindMySkillLevelStep2 from './onboarding/preactivation/FindMySkillLevelStep2';
// import GetReadySkillTest from './onboarding/preactivation/GetReadySkillTest';
// import OnboardingSkillTest from './onboarding/activation/OnboardingSkillTest';
// import PostActivationQuotePage from './onboarding/postactivation/PostActivationQuotePage';
// import PostActivationCoinsEarnedPage from './onboarding/postactivation/PostActivationCoinsEarnedPage';
// import PostActivationStreakCountPage from './onboarding/postactivation/PostActivationStreakCountPage';
// import PostActivationStreakCommitPage from './onboarding/postactivation/PostActivationStreakCommitPage';
// import PostActivationStreakCommitRewardPage from './onboarding/postactivation/PostActivationStreakCommitRewardPage';
// import CourseLanding from './course/CourseLanding';

// const App = () => {
//   return (
//     <UserProvider> {/* <-- Wrap your Router with UserProvider */}
//       <Router>
//         <Routes>
//           <Route path="/" element={<Bootypage />} />
//           <Route path="/quiz" element={<Quizpage />} />
//           <Route path="/welcome" element={<WelcomePage />} />
//           <Route path="/courses" element={<CourseSelection />} />
//           <Route path="/find-course-skill-level" element={<FindCourseSkillLevel />} />
//           <Route path="/find-my-skill-level-step" element={<FindMySkillLevelStep2 />} />
//           <Route path="/get-ready-skill-test" element={<GetReadySkillTest />} />
//           <Route path="/onboarding-skill-test-new" element={<OnboardingSkillTest />} />
//           <Route path="/post-activation-quote" element={<PostActivationQuotePage />} />
//           <Route path="/post-activation-coins-earned" element={<PostActivationCoinsEarnedPage />} />
//           <Route path="/post-activation-streak-count" element={<PostActivationStreakCountPage />} />
//           <Route path="/post-activation-streak-commit" element={<PostActivationStreakCommitPage />} />
//           <Route path="/post-activation-streak-commit-reward" element={<PostActivationStreakCommitRewardPage />} />
//           <Route path="/course-landing" element={<CourseLanding />} />
//         </Routes>
//       </Router>
//     </UserProvider>
//   );
// };

// export default App;




// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Bootypage from './Bootypage';
// import WelcomePage from './Pages2/WelcomePage';
// import Quizpage from './Pages2/Quizpage';
// import CourseSelection from './onboarding/preactivation/CourseSelection';
// import FindCourseSkillLevel from './onboarding/preactivation/FindCourseSkillLevel';
// import FindMySkillLevelStep2 from './onboarding/preactivation/FindMySkillLevelStep2';
// import GetReadySkillTest from './onboarding/preactivation/GetReadySkillTest';
// import OnboardingSkillTest from './onboarding/activation/OnboardingSkillTest';
// // import OnboardingMultipleChoiceQuestion from './onboarding/activation/OnboardingMultipleChoiceQuestion';
// // import OnboardingTrueFalse from './onboarding/activation/OnboardingTrueFalse';
// import PostActivationQuotePage from './onboarding/postactivation/PostActivationQuotePage';
// import PostActivationCoinsEarnedPage from './onboarding/postactivation/PostActivationCoinsEarnedPage';
// import PostActivationStreakCountPage from './onboarding/postactivation/PostActivationStreakCountPage';
// import PostActivationStreakCommitPage from './onboarding/postactivation/PostActivationStreakCommitPage';
// import PostActivationStreakCommitRewardPage from './onboarding/postactivation/PostActivationStreakCommitRewardPage';
// import CourseLanding from './course/CourseLanding';


// const App = () => {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Bootypage />} />
//         <Route path="/quiz" element={<Quizpage />} />
//         <Route path="/welcome" element={<WelcomePage />} />
//         <Route path="/courses" element={<CourseSelection />} />
//         <Route path="/find-course-skill-level" element={<FindCourseSkillLevel />} />
//         <Route path="/find-my-skill-level-step" element={<FindMySkillLevelStep2 />} />
//         <Route path="/get-ready-skill-test" element={<GetReadySkillTest />} />
//         <Route path="/onboarding-skill-test-new" element={<OnboardingSkillTest />} />
//         <Route path="/post-activation-quote" element={<PostActivationQuotePage />} />
//         <Route path="/post-activation-coins-earned" element={<PostActivationCoinsEarnedPage />} />
//         <Route path="/post-activation-streak-count" element={<PostActivationStreakCountPage />} />
//         <Route path="/post-activation-streak-commit" element={<PostActivationStreakCommitPage />} />
//         <Route path="/post-activation-streak-commit-reward" element={<PostActivationStreakCommitRewardPage />} />
//         <Route path="/course-landing" element={<CourseLanding />} />


//       </Routes>
//     </Router>
//   );
// };
// export default App;